/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconColumns1 = createReactComponent("columns-1", "IconColumns1", [
  [
    "path",
    {
      d: "M5 3m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z",
      key: "svg-0"
    }
  ]
]);

export { IconColumns1 as default };
//# sourceMappingURL=IconColumns1.js.map
